import {useCallback, useState} from "react";
import {Section} from "../grouping/Section";
import {Button, Col, Form, FormControl, FormGroup, FormLabel, FormSelect} from "react-bootstrap";
import {SelectionList} from "../SelectionList";
import {ModalPopUp} from "../grouping/ModalPopUp";
import {ListItemButton} from "../ListItemButton";
import {FILE_EMPTY, useFileMutations} from "../../api/fileapi";
import {useForm} from "../../utilities/formutilities";
import {ModalContentContainer} from "../grouping/ModalContentContainer";
import {GALLERY_EMPTY, useGalleryMutations, useGallerys} from "../../api/galleryapi";
import {SelectList} from "./components/SelectList";
import {useAlbums} from "../../api/albumapi";
import {ButtonLoading} from "../ButtonLoading";
import {ConfirmToast} from "../ConfirmToast";

export function GalleryOption(props) {
    const {title} = props;
    const [open, setOpen] = useState(false);
    const [fileEditing, setFileEditing] = useState(undefined);
    const {galleries} = useGallerys();

    return <Section title={title}>
        <Col xs={12} className={"text-end"}>
            <Button onClick={() => setOpen(true)}>Nieuw</Button>
        </Col>
        <SelectionList>
            {galleries ? galleries.map(g => <ListItem key={g.id} onOpenChanged={setOpen}
                                                      insuranceBehaviour={g}
                                                      onFileEditingChanged={setFileEditing}></ListItem>) : ""}
        </SelectionList>
        <ModalPopUp open={open} onOpenChanged={setOpen} title={"Nieuw bestand link"}
                    modalContent={<FileOptionModalContent fileEditing={fileEditing} setFileEditing={setFileEditing}
                                                          onOpenChanged={setOpen}/>}/>

    </Section>
}


function ListItem(props) {
    const {insuranceBehaviour, onOpenChanged, icon, onFileEditingChanged} = props;

    return <div className={"mt-1 border border-black rounded-2"}>
        <ListItemButton onClick={() => {
            onFileEditingChanged(insuranceBehaviour);
            onOpenChanged(true);
        }}>
            <Col className={"text-start"}>
                {insuranceBehaviour ? insuranceBehaviour.title : "Geen Titel"}
            </Col>
            <Col xs={"auto"} className={"text-end"}>
                {icon}
            </Col>
        </ListItemButton>
    </div>
}

function FileOptionModalContent(props) {
    const [isLoading, setIsLoading] = useState(false);
    const {fileEditing, onOpenChanged, setFileEditing} = props;
    const {albums} = useAlbums();
    const [albumsSelected, setAlbumsSelected] = useState(fileEditing ? fileEditing.albums : [])
    const {createGallery, editGallery, editAddNewFiles, editAddAlbums, deleteGallery} = useGalleryMutations();
    const initialObjectInintializer = useCallback(() => fileEditing ? {...fileEditing, dateCreated: fileEditing.dateCreated? fileEditing.dateCreated: new  Date()} : {...GALLERY_EMPTY,dateCreated: new  Date()}, [])
    const initialFileObjectInitializer = useCallback(() => FILE_EMPTY, []);
    const {tempFileObject, onFileInputChange} = useForm(initialFileObjectInitializer);
    const {tempObject, onChange} = useForm(initialObjectInintializer)

    const {uploadFile} = useFileMutations();


    async function handleCreateSubmit(e) {
        e.preventDefault();

        const result = await createGallery(tempObject);
        if (result) {
            if (albumsSelected) await editAddAlbums({...result, albums: albumsSelected});
            if (tempFileObject.file !== "") {
                const objReturn = await uploadFile(tempFileObject);
                if (objReturn) {

                    await editAddNewFiles({...result, fileId: objReturn.id})
                }
            }

        }
        setIsLoading(false)
        onOpenChanged(false)


    }

    async function handleEditSubmit(e) {
        e.preventDefault();
        const result = await editGallery(tempObject);
        if (result) {
            if (albumsSelected) await editAddAlbums({...result, albums: albumsSelected});
            if (tempFileObject.file !== "") {
                const objReturn = await uploadFile(tempFileObject);
                if (objReturn) {
                    await editAddNewFiles({...result, fileId: objReturn.id})
                }
            }
        }
        setIsLoading(false)
        setFileEditing(undefined);
        onOpenChanged(false)
    }

    return <ModalContentContainer onOpenChanged={onOpenChanged} onEditingChanged={setFileEditing}>
        <Form onSubmit={(event) => {
            fileEditing ? handleEditSubmit(event) : handleCreateSubmit(event)
        }}>
            <Section title={fileEditing ? "Wijzig gallerij" : "Nieuwe gallerij"}>
                <FormGroup>
                    <FormLabel>Titel</FormLabel>
                    <FormControl value={tempObject ? tempObject.title : ""}
                                 onChange={event => onChange(event, "title")}/>
                </FormGroup>
                <FormGroup>
                    <FormLabel>Bestand</FormLabel>
                    <FormControl onChange={(e) => onFileInputChange(e, 'file')} type={"file"}/>
                </FormGroup>
                <SelectList list={albums} itemSelected={albumsSelected}
                            onItemSelectedChanged={setAlbumsSelected}/>
                {fileEditing
                    ?
                    <Col xs={6}>
                        <ConfirmToast title={"Delete"} message={"Wil je deze gallerij verwijderen?"}
                                      className={"btn-danger mt-3"} executeFunction={async () => {
                            const message = await deleteGallery(fileEditing);
                            if (message)
                                onOpenChanged(false);
                            setFileEditing(undefined);
                        }}/>
                    </Col>
                    :
                    ""
                }
                <Col xs={fileEditing ? 6 : 12} className={"text-end mt-3"}>
                    <ButtonLoading title={"Opslaan"} isLoading={isLoading} onClick={(e) => {
                        setIsLoading(true);
                        fileEditing ? handleEditSubmit(e) : handleCreateSubmit(e)
                    }}/> </Col>
            </Section>
        </Form>
    </ModalContentContainer>
}